export default from './MobileQuiz';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/MobileQuiz/index.js